"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Ref, Component, PropSync, Mixins } from "vue-property-decorator";
import Question from "@/components/Question.vue";
import { AccountSessionMixins } from "@/service/account-session";
import { Columns, Column } from "../../../virtual-element/elements/table/core";
let VirtualShopTableBody = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.columns = new Columns();
    //表格高度
    this.tableHeight = 0;
  }
  // view_listener: any = null;
  get $controller() {
    return this._controller;
  }
  sortChange(sort) {
    var _a;
    if (sort.order === null) {
      if (this.$controller.query.filter.group) {
        if (this.$controller.query.filter.group === "shopgroup_system_lately") {
          this.$controller.query.sort = "createdTime,desc";
        }
        if (this.$controller.query.filter.group !== "shopgroup_system_lately") {
          this.$controller.query.sort = "createdTime,desc";
        }
      }
    }
    if (sort.order !== null) {
      this.$controller.query.sort = (_a = this.columns.use(sort.prop)) == null ? void 0 : _a.sort(sort);
    }
    this.$controller.search();
  }
  //处理表格选中行数据
  handleSelectionChange(selected) {
    this.$controller.selected.splice(0, this.$controller.selected.length);
    for (const _item of selected) {
      this.$controller.selected.push(_item);
    }
  }
  //清空选中项
  clearSelection() {
    this.$controller.selected.splice(0, this.$controller.selected.length);
    this._tableBody.clearSelection();
  }
  mounted() {
    this._tableBody.doLayout();
  }
  created() {
    return __async(this, null, function* () {
      this.columns.add(
        new Column("name", {
          label: this.$t("main.shop_name").toString(),
          component: require("./columns/ColumnName.vue").default,
          // sort: true,
          sort: "name",
          question: this.$t(
            "main.shop_name_icon_tips"
          ).toString(),
          minWidth: "120px"
        })
      );
      this.columns.add(
        new Column("username", {
          label: this.$t("main.shop_account").toString(),
          component: require("./columns/ColumnUsername.vue").default,
          minWidth: "120px"
        })
      );
      this.columns.add(
        new Column("proxy", {
          label: "IP",
          component: require("./columns/ColumnProxy.vue").default,
          minWidth: "145px"
        })
      );
      this.columns.add(
        new Column("users", {
          label: this.$t("main.authorization").toString(),
          component: require("./columns/ColumnUsers.vue").default,
          // sort: "managerCount",
          sort: "authUserCount",
          question: this.$t(
            "main.number_of_people_allowed_to_visit_the_store"
          ).toString(),
          width: "100px"
        })
      );
      this.columns.add(
        new Column("lastLauncher", {
          label: this.$t("main.last_login").toString(),
          component: require("./columns/ColumnLastLauncher.vue").default,
          width: "150px"
        })
      );
      if (this.$session.type === "account" || this.$session.permissions.is("SHOW_ALL_MENUS")) {
        this.columns.add(
          new Column("shopLock", {
            label: this.$t("main.shop_lock").toString(),
            component: require("./columns/ColumnLock.vue").default,
            width: "95px"
          }),
          "false"
        );
      }
      this.columns.add(
        new Column("online", {
          label: this.$t("vdcontainer.online").toString(),
          component: require("./columns/ColumnOnline.vue").default
        })
      );
      this.columns.add(
        new Column("remark", {
          label: this.$t("vdcontainer.remark").toString(),
          component: require("./columns/ColumnRemark.vue").default
        })
      );
      this.columns.add(
        new Column("operation", {
          // fixed: "right",
          header: {
            component: require("../../../virtual-element/elements/table/headers/HeaderOperate.vue").default
          },
          label: this.$t("vdcontainer.operation").toString(),
          component: require("./columns/ColumnOperate.vue").default,
          width: this.$i18n.locale === "zh-CN" ? "180px" : "220px"
        })
      );
      const _viewStorage = localStorage.getItem("shop.column.view");
      if (_viewStorage !== null) {
        const _view = JSON.parse(_viewStorage);
        this.columns.views(_view);
      }
    });
  }
  // 隐私模式启动
  privacyMode(item) {
    this.$emit("privacyMode", item);
  }
  //打开店铺详情
  shopDetail(item) {
    this.$emit("shopDetail", item);
  }
  //编辑店铺
  editShop(item) {
    this.$emit("editShop", item);
  }
  //绑定IP
  bindIP(item) {
    this.$emit("bindIP", item);
  }
  //绑定IP（店铺回收站）
  bindIPDelete(item) {
    this.$emit("bindIPDelete", item);
  }
  //Cookie备份管理
  cookieEditor(item) {
    this.$emit("cookieEditor", item);
  }
  //分配店铺管理员
  chooseAdmin(item) {
    this.$emit("chooseAdmin", item);
  }
  //删除店铺缓存
  deleteCache(item) {
    this.$emit("deleteCache", item);
  }
  //创建额外访问
  additionalAccess(item) {
    this.$emit("additionalAccess", item);
  }
  //置顶
  stickToTop(item) {
    this.$emit("stickToTop", item);
  }
  //取消置顶
  unstickToTop(item) {
    this.$emit("unstickToTop", item);
  }
  //分组管理
  editGroup(item) {
    this.$emit("editGroup", item);
  }
  //删除店铺
  deleteShop(item) {
    this.$emit("deleteShop", item);
  }
  // 隐藏回收站店铺
  realDeleteShop(item) {
    this.$emit("realDeleteShop", item);
  }
  //修改编号
  changeCode(item) {
    this.$emit("changeCode", item);
  }
  //开启视频认证
  addVideo(item) {
    this.$emit("addVideo", item);
  }
  //关闭视频认证
  closeVideo(item) {
    this.$emit("closeVideo", item);
  }
  //导入cookies
  importCookies(item) {
    this.$emit("importCookies", item);
  }
  //修改备注
  editRemark(item) {
    this.$emit("editRemark", item);
  }
  beforeDestroy() {
    return __async(this, null, function* () {
    });
  }
  openForceDialog(item) {
    this.$emit("openForceDialog", item);
  }
};
__decorateClass([
  Ref("table-body")
], VirtualShopTableBody.prototype, "_tableBody", 2);
__decorateClass([
  PropSync("controller")
], VirtualShopTableBody.prototype, "_controller", 2);
VirtualShopTableBody = __decorateClass([
  Component({
    components: {
      Question
    }
  })
], VirtualShopTableBody);
export {
  VirtualShopTableBody as default
};
